<section id="news">
  <div class="container">
    <div class="row news">
      <div class="col-md-3">
        <div class="news-title">
          CARDATA <span class="fwb">HABER</span>
          <div class="news-icon">
            <span>&nbsp;</span>
            <span>&nbsp;</span>
            <span>&nbsp;</span>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="news-content jsSlideText">
          <div *ngFor="let item of news">
            <!-- <a href="news/{{item.id}}"> -->
            {{item.text}}
            <!-- </a> -->
            <br />
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>